import { CustomerStatusDto, SearchCustomersRequestDto } from '@/api/generated';
import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';
import { Override } from '@/utils/Override.utilityType.ts';

export type CustomerSearchFormModel = Override<
  SearchCustomersRequestDto,
  {
    fullTextSearchInput?: string;
    ownerIdOfCustomerContact: SelectSearchOptionModel | null;
    statuses: SelectSearchOptionModel<CustomerStatusDto>[];
  }
>;

export const initialCustomerSearchFormModel: CustomerSearchFormModel = {
  fullTextSearchInput: '',
  ownerIdOfCustomerContact: null,
  statuses: [],
};
